export default __webpack_public_path__ + "static/media/completed.d7219199.svg";